<template>
    <label class="radio-button">
      <input
        type="radio"
        :value="value"
        :name="name"
        :checked="isChecked"
        @input="handleChange"
      />
      <span class="radio-label">{{ label }}</span>
    </label>
  </template>
  
  <script>
  export default {
    props:["value","name","label","modelValue"],

    computed: {

      isChecked() {
        return this.value === this.modelValue;
      }
    },
    methods: {
      handleChange() {
        this.$emit('update:modelValue', this.value);
      }
    }
  };
  </script>
  
  <style scoped>
  .radio-button {
    display: inline-block;
    margin-right: 10px;
  }
  
  .radio-label {
    margin-left: 5px;
  }
  </style>
    
  